import React from 'react'
import PropTypes from 'prop-types'
import OnMount from './OnMount'
import withEducationInsights from '../withEducationInsights'

EducationInsights.propTypes = {
  track: PropTypes.func.isRequired,
  children: PropTypes.func
}

function EducationInsights({ track, children }) {
  return children ? children(track) : <OnMount callback={track} />
}

export default withEducationInsights(EducationInsights)
